// extracted by mini-css-extract-plugin
export var header = "_i6-0";